module.exports = __webpack_public_path__ + "static/media/info_03.f04ddce7.jpg";